/**
 * A list of names of static menus. These names correspond to different autocomplete search types listed in
 * apps.calculations.autocompleters.
 *
 * Format: <autocomplete search type>.replace('_calc', '')
 *   ex: 'all_calc'.replace('_calc') => 'all'
 *
 * @type {string[]}
 */
export const STATIC_METRIC_MENU_TYPES = [
    'aggregate',
    'all',
    'benchmark_portfolio',
    'benchmark_portfolio_history',
    'bond',
    'bond_history',
    'company',
    'company_fund',
    'company_fund_history',
    'company_history',
    'custom_security',
    'custom_security_history',
    'fund',
    'fund_history',
    'history',
    'index',
    'index_history',
    'model_portfolio',
    'model_portfolio_history',
    'mutual_fund',
    'mutual_fund_history',
    'separate_account',
    'separate_account_history',
    'stock',
    'stock_history',
];
export const STATIC_INFO_MENU_TYPES = [
    'all',
    'benchmark_portfolio',
    'company',
    'stock',
    'company_fund',
    'model_portfolio',
    'mutual_fund',
    'fund',
    'index',
];
function makeStaticMenuUrlMap() {
    const getMetricMenuJsonUrl = (calcType) => `calculations/${calcType}_calc_menu.json`;
    const getMetricLabelMapJsonUrl = (calcType) => `calculations/${calcType}_calc_menu_labels.json`;
    const getInfoFieldMenuJsonUrl = (securityType) => `securities/${securityType}_info_field_menu.json`;
    const getInfoFieldLabelMapJsonUrl = (securityType) => `securities/${securityType}_info_field_menu_labels.json`;
    const jsonUrlMap = {
        metricMenu: {},
        metricLabelMap: {},
        infoFieldMenu: {},
        infoFieldLabelMap: {},
    };
    STATIC_METRIC_MENU_TYPES.forEach((calcType) => {
        jsonUrlMap.metricMenu[calcType] = getMetricMenuJsonUrl(calcType);
        jsonUrlMap.metricLabelMap[calcType] = getMetricLabelMapJsonUrl(calcType);
    });
    STATIC_INFO_MENU_TYPES.forEach((securityType) => {
        jsonUrlMap.infoFieldMenu[securityType] = getInfoFieldMenuJsonUrl(securityType);
        jsonUrlMap.infoFieldLabelMap[securityType] = getInfoFieldLabelMapJsonUrl(securityType);
    });
    return jsonUrlMap;
}
export const STATIC_MENU_URL_MAP = makeStaticMenuUrlMap();
